export default "__VITE_ASSET__713f69c3__"